import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Custom error handler for Angular v21
 * Filters out known ExpressionChangedAfterItHasBeenCheckedError from ngx-toastr
 * and suppresses HttpErrorResponse errors to keep console clean
 */
@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      return;
    }
    if (isDevMode() && error?.message) {
      const message = error.message;
      if (
        message.includes('ExpressionChangedAfterItHasBeenCheckedError') &&
        message.includes('Toast component') &&
        message.includes('display')
      ) {
        return;
      }
    }

    console.error('Application error:', error);
  }
}
